import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  step: {
    height: theme.marginBase * 3,
    width: theme.marginBase * 3,
    padding: theme.marginBase,
  },
  stepDot: {
    height: theme.marginBase,
    width: theme.marginBase,
    borderRadius: '50%',
    backgroundColor: theme.colors.grayBorder,
  },
  stepDotActive: {
    backgroundColor: theme.colors.blueAccessible,
  },
}));

interface Props {
  activeStep: number;
  stepsCount: number;
  requestStepChange: (newStep: number) => any;
  allowForward?: boolean;
}

export const Stepper = ({
  activeStep,
  stepsCount,
  requestStepChange,
  allowForward,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const stepsArray = new Array(stepsCount).fill(0);

  return (
    <div>
      {stepsArray.map((_, index) => (
        <button
          onClick={() => requestStepChange(index)}
          className={classes.step}
          disabled={!allowForward && activeStep < index}
          key={`step-${index}`}
          type="button"
        >
          <div
            className={classnames(classes.stepDot, {
              [classes.stepDotActive]: index === activeStep,
            })}
          />
        </button>
      ))}
    </div>
  );
};
